import React, { useState } from 'react';
import LoadButton from './LoadButton';
import useLoadingForm from '../../hooks/loadingFormHook';
import Username from '../../static/dashboard/username.svg';
import getCancelToken from '../../util/axios';
import axios from 'axios';
import '../../styles/dashboard/DashboardLikes.css';

export default function DashboardLikes({history}) {
    const [cancelLikeToken, setCancelLikeToken] = useState(getCancelToken());

    const submitLikesHandler = () => {
        return axios.get("https://flash.siwalik.in/delay/2000", {
            cancelToken: cancelLikeToken.token
        });
    }

    const likesFormRules = {
        username: [{
            test: (value) => value.length,
            errorMsg: "This is a required field"
        }]
    };

    const { formData, handleChange, loading, loaded, handleSubmit, errorMapping } = useLoadingForm({
        username: ''
    }, submitLikesHandler, null, null, likesFormRules);

    return (
        <div className="DashboardLikes">
            <div className="header">
                <h1>Like Posts</h1>
                <p>Automatically like all of a shop's posts!</p>
            </div>
            <div className="content">
                <form 
                className="formDashboard"
                onSubmit={handleSubmit}>
                    <div className={`username ${errorMapping.username ? 'form-error-input' : ''}`}>
                        <div><img src={Username} alt="@"/></div>
                        <input 
                        className="withIcon"
                        type="text"
                        name="username"
                        value={formData.username}
                        placeholder="sellername"
                        onChange={handleChange} />
                    </div>
                    {errorMapping.username && <p className="form-error">{errorMapping.username}</p>}
                    <LoadButton 
                    loading={loading}
                    loaded={loaded}
                    defaultText="Like All Posts"
                    loadingText="4/28 Liked"
                    loadedText="Liked All"
                    theme="black" />
                </form>
                <button 
                className={loading ? "secondary-button" : "disabled-button"}
                onClick={(e) => {
                    if (loading) {
                        cancelLikeToken.cancel();
                        setCancelLikeToken(getCancelToken());
                    }
                }}>Stop Liking</button>
            </div>
            <p className="disclaimer">DISCLAIMER! Our app is pretty undetectable, 
             but take frequent breaks to ensure you aren’t flagged by Depop</p>
        </div>
    )
}